
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/notification-settings",
      function () {
        return require("private-next-pages/profile/notification-settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/notification-settings"])
      });
    }
  